import script from "./WalletView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletView.vue?vue&type=script&setup=true&lang=ts"

import "./WalletView.vue?vue&type=style&index=0&id=b365f5e8&lang=css"

const __exports__ = script;

export default __exports__